// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__cdsHt","resendInfoText":"OnGoingPaymentBox_resendInfoText__1TdDL"};